import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import { catchError, forkJoin, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactoFrontService {

  constructor(
    private edicionSeccionesService: EdicionSeccionesService,
    private preferenciasService: PreferenciasService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    let peticion = {
      clave_matrix_mapaApikeyServidor: this.preferenciasService.getApi('matrix_mapaApikeyServidor').pipe(
        catchError(err => of(null))
      ), 
      precargaMeta: this.edicionSeccionesService.getContenidoBloquesSubseccion('contacto-meta').pipe(
        catchError(err => of(err))
      )
    };

    return forkJoin(peticion);
  }
}
